export const PermittedNavItems = (permissions, navItems) => {
  const updateHidden = item => {
    const hidden = !permissions.some(permission => {
      if (permission.subEvents != null) {
        return (
          permission.subEvents.events.screens.screenName.toUpperCase() ==
            item.navTitle?.toUpperCase() ||
          item.navTitle === 'Global' ||
          item?.navTitle === 'Dashboard'
        )
      } else {
        return (
          permission.events.screens.screenName.toUpperCase() ==
            item.navTitle?.toUpperCase() ||
          item.navTitle === 'Global' ||
          item?.navTitle === 'Dashboard'
        )
      }
    })
    return { ...item, hidden }
  }
  const updateHiddenSubMenu = item => {
    const hidden = !permissions.some(permission => {
      if (permission.subEvents != null) {
        return (
          permission.subEvents.events.eventName.toUpperCase() ==
          item.navTitle?.toUpperCase()
        )
      } else {
        return (
          permission.events.eventName.toUpperCase() ==
          item.navTitle?.toUpperCase()
        )
      }
    })
    return { ...item, hidden }
  }

  const updateMenuItems = items => {
    return items.map(item => {
      let updatedItem
      if (item.externalMenu) {
        updatedItem = {
          ...item,
          externalMenu: updateMenuItems(item.externalMenu),
        }
        const hidden = updatedItem?.externalMenu?.every(item => item.hidden)
        updatedItem = {
          ...item,
          hidden,
          externalMenu: updatedItem?.externalMenu,
        }
      }
      // else if (item?.path?.includes('/reports')) {
      //   updatedItem = updateHiddenSubMenu(item)
      // }
      else {
        updatedItem = updateHidden(item)
      }

      return updatedItem
    })
  }

  return updateMenuItems(navItems)
}

const EVENTCRUDS = [
  'New Student',
  'View',
  'Actions',
  'Reschedule Drive',
  'VIEW REPORT',
  'Pending Drive Request',
  'DRIVE INFO',
  'Add User',
  'Edit',
  'Delete',
  'Save Changes',
  'Update',
  'New Courses',
  'BULK UPLOAD',
  'UPDATE',
  'BLACKLIST',
  'CANDIDATE APPLICATION STATUS',
  'ACTIVE ROLES',
  'CORPORATES ACTIVELY ENGAGED',
  'CANDIDATE MASTER',
  'ACTIVE/INACTIVE',
  'ACCEPT/REJECT',
  'RESENT INVITE',
]

export const permittedEventCruds = (permissions, screenName) => {
  const foundPermissions = permissions?.filter(permission => {
    return EVENTCRUDS?.find(cruds => {
      if (
        permission?.screens?.screenName?.toUpperCase()?.trim() ===
        screenName?.toUpperCase()?.trim()
      ) {
        return (
          permission?.events?.eventName?.toUpperCase()?.trim() ===
          cruds.toUpperCase()?.trim()
        )
      }
    })
  })
  return foundPermissions
}

const SUBEVENTCRUDS = [
  'SHARE JOB DETAILS',
  'EXPORT',
  'SCHEDULE A DRIVE',
  'REQUEST TO CHANGE',
  'VIEW & CONFIRM',
  'CONFIRM',
  'VIEW MORE',
  'VIEW',
  'DOWNLOAD RESUME',
  'REMOVE CANDIDATE',
]

export const permittedSubEventCruds = (permissions, screenName) => {
  const foundPermissions = permissions?.filter(permission => {
    return SUBEVENTCRUDS?.find(cruds => {
      if (
        permission?.screens?.screenName?.toUpperCase()?.trim() ===
        screenName?.toUpperCase()?.trim()
      ) {
        return (
          permission?.subEvents?.subEventName?.toUpperCase()?.trim() ===
          cruds.toUpperCase()?.trim()
        )
      }
    })
  })
  return foundPermissions
}

export const crudMatcher = (crud, eventName) => {
  return crud?.some(item => item.eventName === eventName)
}

export const permittedCruds = (permissions, screenName) =>
  !permissions?.length
    ? EVENTCRUDS
    : EVENTCRUDS?.filter(cruds => {
        return permissions.find(permission => {
          if (
            permission?.subEvents != null &&
            permission?.subEvents?.events?.screens?.screenName?.toUpperCase() ===
              screenName?.toUpperCase()
          ) {
            return (
              permission?.subEvents?.events?.eventName
                ?.toUpperCase()
                ?.trim() === cruds.toUpperCase()?.trim()
            )
          } else if (
            permission?.events?.screens?.screenName?.toUpperCase()?.trim() ===
            screenName?.toUpperCase()?.trim()
          ) {
            return (
              permission?.events?.eventName?.toUpperCase()?.trim() ===
              cruds?.toUpperCase()?.trim()
            )
          }
        })
      })

export const permittedSubEvents = (permissions, screenName, eventName) =>
  !permissions?.length
    ? SUBEVENTCRUDS
    : SUBEVENTCRUDS?.filter(cruds => {
        return permissions.find(permission => {
          if (
            permission?.subEvents != null &&
            permission?.subEvents?.events?.screens?.screenName?.toUpperCase() ===
              screenName?.toUpperCase() &&
            permission?.subEvents?.events?.eventName?.toUpperCase() ===
              eventName?.toUpperCase()
          ) {
            return (
              permission?.subEvents?.subEventName?.toUpperCase()?.trim() ===
              cruds.toUpperCase()
            )
          }
        })
      })

export const PermittedNavRoutes = (permissions, navItems) =>
  !permissions?.length
    ? navItems
    : navItems?.filter(oldData => {
        return permissions?.find(newData => {
          if (newData?.screens != null) {
            return (
              newData?.screens?.screenName?.toLocaleUpperCase() ===
                oldData?.navTitle?.toUpperCase() ||
              oldData?.navTitle === 'Dashboard' ||
              oldData?.navTitle === 'Global' ||
              !oldData?.navTitle
            )
          }
        })
      })
